export const getTabIdentifiers = (tabId: string) => {
  return {
    tabIdentifier: `tab-${tabId}`,
    tabPanelIdentifier: `tab-panel-${tabId}`,
  }
}
